import { useState } from 'react'

type ModificationMaster = {
  id: number
  platforms: string[]
}

export const useMaster = () => {
  const [masters, setMasters] = useState<ModificationMaster[]>([{ id: 1, platforms: [] }])

  const addMaster = () => {
    setMasters(currentMasters => {
      const nextId = Math.max(...currentMasters.map(master => master.id), 0) + 1
      return [...currentMasters, { id: nextId, platforms: [] }]
    })
  }
  const removeMaster = (id: number) => {
    setMasters(currentMasters =>
      currentMasters.length === 1 ? currentMasters : currentMasters.filter(master => master.id !== id),
    )
  }
  const clearMasterPlatforms = (id: number) => {
    setMasters(currentMasters =>
      currentMasters.map(master => (master.id === id ? { ...master, platforms: [] } : master)),
    )
  }
  const toggleMasterPlatform = (id: number, platform: string, checked: boolean) => {
    setMasters(currentMasters =>
      currentMasters.map(master => {
        if (master.id !== id) {
          return master
        }

        return {
          ...master,
          platforms: checked ? [...master.platforms, platform] : master.platforms.filter(value => value !== platform),
        }
      }),
    )
  }

  return {
    masters,
    addMaster,
    removeMaster,
    clearMasterPlatforms,
    toggleMasterPlatform,
  }
}
